export default __webpack_public_path__ + "static/media/sent.ed1c37de.png";